const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? `${window.location.protocol}//${window.location.hostname}:8001`;
const PUBLIC_DOMAIN = 'https://www.frostbound.org';

const CATEGORY_FALLBACK = {
  PARCHE: '/news-fallbacks/parche.jpg',
  EVENTO: '/news-fallbacks/evento.jpg',
  PVP:    '/news-fallbacks/pvp.jpg',
  AVISO:  '/news-fallbacks/aviso.jpg',
};

const IMG_SRC_RE = /<img[^>]+src=["']([^"']+)["']/i;

function extractFirstImage(html) {
  if (!html) return null;
  const m = html.match(IMG_SRC_RE);
  if (!m) return null;
  const src = m[1];
  if (src.startsWith('/uploads/')) return `${BACKEND_URL}${src}`;
  if (src.includes('/uploads/')) return `${BACKEND_URL}/uploads/${src.split('/uploads/')[1]}`;
  return src;
}

function getFallback(category) {
  return CATEGORY_FALLBACK[category] || '/news-fallbacks/default.jpg';
}

export function resolveUploadUrls(html) {
  if (!html) return html;
  return html
    .replace(/src="https?:\/\/[^"]*\/uploads\//g, `src="${BACKEND_URL}/uploads/`)
    .replace(/src="\/uploads\//g, `src="${BACKEND_URL}/uploads/`);
}

export function getCoverUrl(item) {
  if (!item) return getFallback(null);
  const { image_url, content, category } = item;
  if (image_url) {
    if (image_url.startsWith('http')) return image_url;
    if (image_url.startsWith('/uploads/')) return `${BACKEND_URL}${image_url}`;
  }
  const fromContent = extractFirstImage(content);
  if (fromContent) return fromContent;
  return getFallback(category);
}

export function getOgImageUrl(item) {
  const url = getCoverUrl(item);
  if (url.startsWith('http')) return url;
  return `${PUBLIC_DOMAIN}${url}`;
}
